class MvAnime {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    gsap.set([
      ".js-common-mv-img",
      ".js-common-mv-text",
      ".js-common-mv-copy"
    ], {
      clipPath: "inset(0 100% 0 0)"
    });
    
    gsap.set(".js-common-mv-img", {
      clipPath: "none",
      opacity: 0,
      y: 40
    });
    
    const tl = gsap.timeline();
    
    tl.to(".js-common-mv-img", {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    })
    
    .to(".js-common-mv-text", {
      clipPath: "inset(0 0% 0 0)",
      duration: 0.4,
      ease: "power2.out"
    }, "+=0.1")
    
    .to(".js-common-mv-copy", {
      clipPath: "inset(0 0% 0 0)",
      duration: 0.4,
      ease: "power2.out"
    }, "+=0.1");
    
    
  }
}